import React, { createContext, useContext, useState, useEffect } from 'react';

const HotelContext = createContext();

export const useHotelContext = () => {
  const context = useContext(HotelContext);
  if (!context) {
    throw new Error('useHotelContext must be used within a HotelProvider');
  }
  return context;
};

export const HotelProvider = ({ children }) => {
  const [hotelId, setHotelId] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    try {
      const userStr = localStorage.getItem('user');
      if (userStr) {
        const user = JSON.parse(userStr);
        setHotelId(user.hotel);
      }
    } catch (error) {
      console.error('Error while retrieving hotelId:', error);
    } finally {
      setLoading(false);
    }
  }, []);

  const value = {
    hotelId,
    loading,
    setHotelId
  };

  return (
    <HotelContext.Provider value={value}>
      {children}
    </HotelContext.Provider>
  );
}; 